import React from "react";
import UserCard from "./../Components/UserCard";

const TestimonialCard = ({ quote, author, role, authorProfilePic }) => {
  return (
    <div className="flex flex-col font-satoshi text-white">
      <p className="text-lg md:text-3xl font-medium drop-shadow-lg leading-snug items-center text-center tracking-normal">
        {quote}
      </p>
      <UserCard
        className="pt-8 transition-all duration-300 ease-in-out"
        username={author}
        position={role}
        userProfilePic={authorProfilePic}
      />
    </div>
  );
};

export default TestimonialCard;
